(function () {
  if (customElements.get('salut-mmenu')) return;

  class SalutMmenu extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.body = this.querySelector('.salut-mmenu__body');
      this.bar = this.querySelector('[data-salut-mmenu-bar]');
      this.desktopQuery = window.matchMedia('(min-width: 990px)');
      this.onDocumentClick = (event) => {
        const trigger = event.target.closest('[data-salut-mmenu-open]');
        if (!trigger) return;
        event.preventDefault();
        this.open();
      };
      this.onDesktopChange = (event) => {
        if (event.matches) this.close();
      };
      this.onPageHide = () => {
        if (!this.dialog.open) return;
        this.close();
        this.afterClose();
      };
      document.addEventListener('click', this.onDocumentClick);
      this.desktopQuery.addEventListener('change', this.onDesktopChange);
      window.addEventListener('pagehide', this.onPageHide);

      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => this.handleClick(event));
      this.dialog.addEventListener('close', () => this.afterClose());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.observeSlider();
    }

    disconnectedCallback() {
      if (this.dialog && this.dialog.open) this.afterClose();
      document.removeEventListener('click', this.onDocumentClick);
      this.desktopQuery.removeEventListener('change', this.onDesktopChange);
      window.removeEventListener('pagehide', this.onPageHide);
    }

    handleClick(event) {
      if (event.target.closest('[data-salut-mmenu-close]')) return this.close();

      if (event.target.closest('[data-salut-ask]')) {
        this.close();
        return this.openChat();
      }

      const panel = event.target.closest('[data-salut-panel]');
      if (panel) {
        this.origin = panel;
        this.trail = [];
        this.showPanel(panel.dataset.salutPanel);
        return this.focusScreen('panels');
      }

      const screen = event.target.closest('[data-salut-screen]');
      if (screen) {
        event.preventDefault();
        const name = screen.dataset.salutScreen;
        const trail = this.trail || (this.trail = []);
        if (name === 'main' && trail.length) {
          const previous = trail.pop();
          this.showScreen(previous.screen);
          return this.focusReturn(previous);
        }
        if (this.currentScreen === 'main') {
          this.origin = screen;
          this.trail = [];
        } else if (name !== 'main') {
          trail.push({ screen: this.currentScreen, opener: screen });
        }
        this.showScreen(name);
        return this.focusScreen(name);
      }

      const chip = event.target.closest('[data-scroll-to]');
      if (chip) {
        const target = document.getElementById(chip.dataset.scrollTo);
        if (target) target.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }

    open() {
      if (this.dialog.open) return;
      this.updateBar();
      this.trail = [];
      this.showScreen('main');
      this.dialog.showModal();
      document.body.classList.add('overflow-hidden');
      document.dispatchEvent(new CustomEvent('salut-mmenu:open', { detail: { menu: this } }));
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }

    afterClose() {
      document.body.classList.remove('overflow-hidden');
    }

    openChat() {
      const chat = window.GorgiasChat;
      if (!chat) {
        if (this.dataset.askFallback) window.location.href = this.dataset.askFallback;
        return;
      }
      this.chatReady = this.chatReady || chat.init();
      this.chatReady.then(() => chat.open());
    }

    focusScreen(name) {
      const target = name === 'main'
        ? this.origin
        : this.querySelector(`[data-screen="${name}"] .salut-mmenu__back`);
      if (target && target.isConnected && target.offsetParent !== null) target.focus({ preventScroll: true });
    }

    focusReturn(previous) {
      const fallback = this.querySelector(`[data-screen="${previous.screen}"] .salut-mmenu__back`);
      const target = previous.opener && previous.opener.isConnected && previous.opener.offsetParent !== null
        ? previous.opener
        : fallback;
      if (target) target.focus({ preventScroll: true });
    }

    showScreen(name) {
      this.currentScreen = name;
      this.querySelectorAll('[data-screen]').forEach((screen) => {
        screen.hidden = screen.dataset.screen !== name;
      });
      this.body.scrollTop = 0;
      this.dispatchEvent(new CustomEvent('salut-mmenu:screen', { detail: { name }, bubbles: true }));
    }

    showPanel(handle) {
      this.querySelectorAll('[data-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.panel !== handle;
      });
      this.showScreen('panels');
    }

    updateBar() {
      if (!this.bar || !window.SalutMenuLogic) return;
      const schedule = window.SalutMenuLogic.parseSchedule(this.dataset);
      this.bar.dataset.open = String(window.SalutMenuLogic.isWithinSchedule(schedule, new Date()));
    }

    observeSlider() {
      const slider = this.querySelector('[data-salut-slider]');
      const dots = this.querySelectorAll('[data-salut-dots] .salut-mmenu__dot');
      if (!slider || dots.length < 2 || !('IntersectionObserver' in window)) return;
      const slides = [...slider.children];
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const index = slides.indexOf(entry.target);
            dots.forEach((dot, position) => dot.classList.toggle('is-active', position === index));
          });
        },
        { root: slider, threshold: 0.6 }
      );
      slides.forEach((slide) => observer.observe(slide));
    }
  }

  customElements.define('salut-mmenu', SalutMmenu);
})();
